export enum ACCOUNT_TYPE {
  SCHOOL = 'School',
  DISTRICT = 'District',
  NON_PROFIT = 'Non-Profit',
}
